import Login from 'views/login/Login.container';

export default Login;
